<template>
  <b-container>
    <div class="b-main-content">
      <h2>Smartpress</h2>
      <p>
        <b-button 
          variant="outline-dark" 
          to="signUp">Sign Up</b-button>
      </p> 
    </div>
  </b-container>
</template>

<script>
export default {
    
}
</script>

